import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class IncomeClassificationCategoryValueObject  {
    _originalTypeClassName = "zERP.BO.IncomeClassificationCategoryValueObject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
IncomeClassificationCategoryValueObject.translate = translateService;
}
this.Types = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this.CodeStr = null;
this.FullName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;
CodeStr:any;
FullName:any;
Types:any;
static setTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.Types == null) $this.Types = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Types.length > 0) {
                    Domain.IncomeClassificationCategoryValueObject.removeTypes($this, $this.Types[0]);
                }

                Domain.IncomeClassificationCategoryValueObject.addManyTypes($this, copyItems);
            }
static addManyTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.IncomeClassificationCategoryValueObject.addTypes($this, items[i]);
                }
            }
static addTypes = ($this, item) => {
                if ($this.Types == null) $this.Types = [];
                if (item == null || $this.Types.indexOf(item) > -1) return;
                $this.Types.push(item);
Domain.IncomeClassificationTypeValueObject.addCategory(item, $this);
}
static addRangeTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.IncomeClassificationCategoryValueObject.addTypes($this, item));
            }
static removeTypes = ($this, item) => {
                if ($this == null || $this.Types == null || $this.Types.indexOf(item) === -1) return;
                var _index = $this.Types.indexOf(item);
                $this.Types.splice(_index, 1);
Domain.IncomeClassificationTypeValueObject.removeCategory(item, $this);
}
static clearTypes = ($this) => { $this.Types = null; }

static CodeToDescription($this: any): any{switch ($this?.Code) {case Domain.IncomeClassificationCategoryType.category1_1:
{
return "Έσοδα από Πώληση Εμπορευμάτων";}
case Domain.IncomeClassificationCategoryType.category1_2:
{
return "Έσοδα από Πώληση Προϊόντων";}
case Domain.IncomeClassificationCategoryType.category1_3:
{
return "Έσοδα από Παροχή Υπηρεσιών";}
case Domain.IncomeClassificationCategoryType.category1_4:
{
return "Έσοδα από Πώληση Παγίων";}
case Domain.IncomeClassificationCategoryType.category1_5:
{
return "Λοιπά Έσοδα/ Κέρδη";}
case Domain.IncomeClassificationCategoryType.category1_6:
{
return "Αυτοπαραδόσεις / Ιδιοχρησιμοποιήσεις";}
case Domain.IncomeClassificationCategoryType.category1_7:
{
return "Έσοδα για λ/σμο τρίτων";}
case Domain.IncomeClassificationCategoryType.category1_8:
{
return "Έσοδα προηγούμενων χρήσεων";}
case Domain.IncomeClassificationCategoryType.category1_9:
{
return "Έσοδα επομένων χρήσεων";}
case Domain.IncomeClassificationCategoryType.category1_10:
{
return "Λοιπές Εγγραφές Τακτοποίησης Εσόδων";}
case Domain.IncomeClassificationCategoryType.category1_95:
{
return "Λοιπά Πληροφοριακά Στοιχεία Εσόδων";}
default:
{
return "";}
}
}
static GetCodeStr($this: any): any{return $this?.Code + "";
}
static GetEnums(): any{let incomeClassificationCategoryTypes = [];
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_1);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_2);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_3);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_4);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_5);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_6);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_7);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_8);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_9);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_10);
incomeClassificationCategoryTypes?.add(Domain.IncomeClassificationCategoryType.category1_95);
return incomeClassificationCategoryTypes;
}
static GetFullName($this: any): any{return $this?.Code + " - " + $this?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}